import { css } from 'styled-components';
import { StyledCarouselNavControls } from '../../components/CarouselNavControls/CarouselNavControls.styles';
import { StyledCarouselSlide } from '../../components/CarouselSlide/CarouselSlide.styles';

/** @class CarouselMixin */
/** @method */
export var CarouselMixin = /*#__PURE__*/css(["position:relative;", " + ", "{margin-top:0;}", "{display:none;}@media (hover:hover) and (pointer:fine){", "{display:flex;}}"], StyledCarouselSlide, StyledCarouselSlide, StyledCarouselNavControls, StyledCarouselNavControls);